/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2021 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import React, { Component } from "react";
import RenderChart from '../charts/RenderChart'
import gradeStyle from './gradesummary.scss';
import { convertToMsColumnForamat, getCurrentYear, ShowCompare } from '../../common/utils';
import EdwSwitchButton from '../common/edwSwitchButton/EdwSwitchButton';
import style from '../../styles.module.scss';
import gradeConfig from '../../common/widgetConfigs/gradeSummary'
import gridconfig from '../../common/tableConfig/gridConfig'
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import asyncCallHandler from '../../common/utils/asyncCallHandler'
import EDW_CONST from '../../common/constants';
import tableStyle from '../../component/common/style/index.scss';
import { EdwLoaderWithContainer } from '../common/edwLoaderWithContainer/EdwLoaderWithContainer';
import { ErrorData } from "../common/noData/NoData";
import { EDWDropDown } from "../common/dropDown/DropDown";
export class GradeSummary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            chartConfig: gradeConfig.chartConfig,
            isDataLoaded: false,
            showChart: true,
            sortValue: 'asc',
            performanceData: [],
            coloumnDef: [],
            rowData: [],
            tableIcons: gridconfig.icons,
            isDataFetch: false,
            groupCourse: [],
            legendsClass: gradeConfig.legendsClass,
            groupId: [],
            compareTags: [],
            selectedGroup:[],
            isApiFail:false,
            isShowCompare: ShowCompare(props.dateTaken)
        }
        this.iesToken = props.token ? props.token : ''
    }

    componentDidMount() {
        let groupIds = [... this.state.groupId]
        groupIds.push(this.props.groupId);       
        this.fetchGradeSummary(groupIds);
        this.fetchGroups();
    }
    fetchGradeSummary(groupIds) {

        let { assessmentId, schoolId, dateTaken, studentYear } = this.props;
        let groupId = groupIds.join(',')
        this.setState({ isDataFetch: false, groupId: groupIds})
        asyncCallHandler(EDW_CONST.ASSESSMENT_END_POINT, `gradePerformanceData?assessmentId=${assessmentId}&groupId=${groupId}&examDate=${dateTaken}&schoolId=${schoolId}&studentYear=${studentYear}`, this.iesToken).then(response => {

            let chartConfigs = this.getChartProps(response.data);
            // let chartConfigs = this.getChartProps(gradeConfig.performanceData)

            this.setState({ chartConfig: chartConfigs, isDataFetch: true, performanceData: response.data });

        }).catch((error) => {
            this.setState({ performanceData: [], isApiFail:true});
            console.log("axios error:", error);
        });
    }
    fetchGroups() {
        let { schoolId, courseId, assessmentId } = this.props;
        let acadamicYear = getCurrentYear();
        asyncCallHandler(EDW_CONST.COMMON_END_POINT, `getGroupsByCourse?schoolId=${schoolId}&courseId=${courseId}&assessmentId=${assessmentId}&academicYear=${acadamicYear}`, this.iesToken).then(response => {
            this.setState({ groupCourse: response.data })
        }).catch((error) => {
            this.setState({ groupCourse: [] });
            console.log("axios error:", error);
        });
    }

    componentDidUpdate(prevProps, prevState) {
        
        if (
            this.props.groupId !== prevProps.groupId ||
            this.props.studentYear !== prevProps.studentYear
        ) {
            let groupIds =[];
            groupIds.push(this.props.groupId);
            this.fetchGradeSummary(groupIds);
        }
    }

    getChartProps = (performanceData) => {

        let gradeData = convertToMsColumnForamat(performanceData);
        let chartConfigs = Object.assign({}, this.state.chartConfig);
        let { width, height, token, categories, dataset } = this.props;

        chartConfigs.width = width;
        chartConfigs.height = height;

        chartConfigs.dataSource.chart.xAxisname = this.props.xAxisname ? this.props.xAxisname : 'Indicative grade'
        chartConfigs.dataSource.chart.yAxisName = this.props.yAxisName ? this.props.yAxisName : 'Number of <br/>students'
        chartConfigs.dataSource.dataset = gradeData.dataset;
        chartConfigs.dataSource.categories =[]
        chartConfigs.dataSource.categories.push({ category: gradeData.category });
        let lengthArr = 0;
        gradeData.rowData.reduce((accumulator, currentValue) => {
             lengthArr++
             return;
             },0 )
        let tableHeight = 100 + (parseInt(lengthArr) * 40);
        this.setState({ coloumnDef: gradeData.columDef, rowData: gradeData.rowData, height: tableHeight })
        this.props.updateExportData({ type: "grade_widget_1", rowData: gradeData.rowData, columnDefs: gradeData.columDef });
        return chartConfigs;
    }
    switchView = (e) => {
        this.setState({ showChart: e.target.checked })
        let chartConfigs = Object.assign({}, this.state.chartConfig);
        if (e.target.checked) {
            // chartConfigs = this.getChartProps(this.state.performanceData);
        }
        this.setState({ chartConfig: chartConfigs });
    }
    getTableView = () => {
        return <div className="ag-theme-alpine" style={{
            height: this.state.height, width: '920px', margin: '0 auto', padding: '0px',
            position: 'relative'
        }} >
            <AgGridReact tooltipShowDelay={0}
                columnDefs={this.state.coloumnDef}
                rowData={this.state.rowData}
                icons={this.state.tableIcons}
                onSortChanged={this.onSortChanged.bind(this)}
            />

        </div>
    }
    sort_by_key = (array, key) => {
        return array.sort(function (a, b) {
            var x = a[key]; var y = b[key];
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        });
    }
    onSortChanged = (params) => {
        let sortModel = params.api.getSortModel();
        let sortedRowData = this.sort_by_key(this.state.rowData, sortModel[0]["colId"]);
        this.setState({ rowData: sortedRowData });
    }
    getChartView = () => {
        return <div className="chartCls">
            <RenderChart chartConfigs={this.state.chartConfig} fusionKey={this.props.fusionKey}/>
        </div>
    }
    compareChart = (e) => {
       
        let groupIds = [... this.state.groupId]
        let compareTags = [... this.state.compareTags];
        let selectedGroup = [...this.state.selectedGroup];
        compareTags = [];
        selectedGroup = [];
        groupIds.splice(1);
        if(e.length>0){
            e.map((val) => {
                if (val != "") {
                    let selectedOption = val.split("/");
                    let index = groupIds.indexOf(selectedOption[0]);
                    if (index == -1) {
                        selectedGroup.push(val)
                        groupIds.push(selectedOption[0]);
                        compareTags.push({ key: selectedOption[1], value: selectedOption[0] })
                     }                 
                }
            })
        }
       
        this.setState({ groupId: groupIds, compareTags: compareTags, selectedGroup: selectedGroup })
        this.fetchGradeSummary(groupIds);       
    }
    dropDownView(options) {

        return (
            <EDWDropDown
                items={options.filter(
                    id => id.id !== this.props.groupId
                ).map(val => {
                    return {
                        id: val.id + '/'+val.label , label: val.label
                    }
                })}
                onChange={this.compareChart}
                label="Select Group/course"
                multiple
                selectAllActive='false'
                value={this.state.selectedGroup.filter(id => id)}
            />          
        )
    }
    GradeScaleList(performanceData) {
        return (<div className="row">
            {
                performanceData[0].gradeScale.map((val, index) => {
                    return <span key={index} className={[gradeStyle.gradeScale, 'content-row-padding'].join(' ')} >{val.key} = {val.value}%</span>
                })
            }
        </div>)
    }
    showLegends(performanceData) {
         if (performanceData.length > 0) {
            return (
                <div className={[gradeStyle.legendsBox, "row", "content-row-padding"].join(" ")}>
                    {
                        performanceData.map((summary,key)=>{ 
                            return(
                                summary.results.map((val) => {
                                  
                                    return <div key={key} className={[gradeStyle.legends, "labelMarkleft", "checkboxCls"].join(" ")}>
                                        <i className={[this.state.legendsClass[key], 'iconAverage'].join(' ')}></i>
                                        <p>{val.groupName}</p>
                                    </div>

                                })
                            )                           
                           
                        })
                    }

                </div>
            )
        }
    }
    removeCompare(value, key, groupid) {
        let groupIds = [...groupid];
        let selectedGroup = [...this.state.selectedGroup]
        
        let index = groupIds.indexOf(value)
        if (index !== -1) {
            groupIds.splice(index, 1);            
        }
        selectedGroup.splice(key, 1);       
        let compareTags = [... this.state.compareTags];
        compareTags.splice(key, 1);
        this.setState({ groupId: groupIds, compareTags: compareTags, selectedGroup: selectedGroup });
        this.fetchGradeSummary(groupIds);
    }
    showCompareTags(compareTags) {
        if (compareTags.length > 0) {
            return (<div className="row">
                {
                    compareTags.map((val, key) => {
                        return <span key={key} className={[gradeStyle.gradeScale, 'content-row-padding'].join(' ')} >{val.key}
                            <button type="button" class={[gradeStyle.closeBtn, 'close'].join(' ')} aria-label="Close" onClick={() => { this.removeCompare(val.value, key, this.state.groupId) }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </span>
                    })
                }
            </div>)
        }
    }

    getChartBlock = () => {

        if (!this.state.isDataFetch && !this.state.isApiFail)
            return <EdwLoaderWithContainer />
        else if (this.state.isDataFetch && this.state.performanceData.length > 0 && !this.state.isApiFail) {
            return <div className="chartCls">
                <RenderChart chartConfigs={this.state.chartConfig} fusionKey={this.props.fusionKey}/>
                </div>
        }
        else 
            return <ErrorData />
        
    }


    render() {
        let switchProps = {
            leftLable: EDW_CONST.TABLE_VIEW,
            rightLable: EDW_CONST.GRAPH_VIEW,
            checked: this.state.showChart,
            handleChange: this.switchView
        }
        return (
            < div >
                <div className="col">
                    <div className="row">
                        <div className="col-md-8 chartTitle">
                            <label><span className="card-title">Grade summary</span></label>
                        </div>
                    </div>
                    {(this.state.isDataFetch && this.state.performanceData.length > 0) && 
                    <div className="row content-row-padding" style={{paddingRight: 9}}>
                        <div style={{ flexGrow: 1, marginRight: 20 }}></div>
                        <div style={{ width: 320, marginRight: 20 }}>
                            {this.state.isShowCompare &&
                                <div>
                                    <label className={style.lblColor}>Compare with</label>
                                    {this.dropDownView(this.state.groupCourse)}
                                </div>
                            }  
                        </div>
                        <div>
                            <div className="edw-switch-btn-adj">
                                <EdwSwitchButton {...switchProps} />
                            </div>
                        </div>
                    </div>
                    }
                    {this.state.isDataFetch && this.state.performanceData.length > 0 ? (this.showCompareTags(this.state.compareTags)) : ''}
                    {this.state.isDataFetch && this.state.performanceData.length > 0 ? (this.showLegends(this.state.performanceData)) : ''}

                    <div className="row">
                        {this.state.showChart && <div className="edw-full-width">
                            {/*{this.state.isDataFetch ? (this.getChartView()) : <EdwLoaderWithContainer />}*/}
                            {this.getChartBlock()}
                        </div>
                        }
                        {!this.state.showChart && <div className="center-align">
                            {this.state.isDataFetch ? (this.getTableView()) : ''}
                        </div>
                        }
                    </div>

                    {this.state.isDataFetch && this.state.performanceData.length > 0 ? (this.GradeScaleList(this.state.performanceData)) : ''}

                </div>
            </div>

        );
    }
}


